<span class="csv-export-progress">
  <span class="spinner-border spinner-border-sm align-middle me-1" role="status" aria-hidden="true"></span>
  <span class="csv-export-progress-label">Exporting {{ current }}&nbsp;/&nbsp;{{ total }}…</span>
  <span class="csv-export-progress-bar" [style.width.%]="percent"></span>
</span>
